import { ErrorResponse } from '../utils/errorUtils';

export const ZIPCODE_NOT_FOUND_ERROR_CODE = 'PSTL_ERR_001';
export const ADDRESS_LIMIT_ERROR_CODE = 'ADDR_ERR_144';

export const INVALID_PAYMENT_ERROR_CODES = [
  'PYMTCRD_ERR_202',
  'PYMTCRD_ERR_203',
  'PYMTCRD_ERR_204',
  'PYMTCRD_ERR_279',
  'PYMTCRD_ERR_280',
  'PYMTCRD_ERR_310',
];

export const getIsAuthError = (error: ErrorResponse) => {
  if (error?.graphQLErrors && Array.isArray(error.graphQLErrors)) {
    return error.graphQLErrors.some((graphQLError: { message: string }) => {
      return (
        graphQLError?.message &&
        typeof graphQLError.message === 'string' &&
        graphQLError.message.includes('AUTH_ERR_105')
      );
    });
  }
  return false;
};

export const hasMaxAddressError = (error: ErrorResponse) => {
  if (error?.graphQLErrors && Array.isArray(error.graphQLErrors)) {
    return error.graphQLErrors.some((graphQLError: { message: string }) => {
      return (
        graphQLError?.message &&
        typeof graphQLError.message === 'string' &&
        graphQLError.message.includes(ADDRESS_LIMIT_ERROR_CODE)
      );
    });
  }
  return false;
};

export const getIsCardAlreadyOnAccount = (errors: []) => {
  return errors.some((graphQLError: { message: string }) => {
    return (
      graphQLError?.message &&
      typeof graphQLError.message === 'string' &&
      graphQLError.message.includes('PYMTCRD_ERR_197')
    );
  });
};

export const isInvalidPaymentAuthAttempt = (errors: []) => {
  return errors.some((graphQLError: { message: string }) => {
    return (
      graphQLError?.message &&
      typeof graphQLError.message === 'string' &&
      INVALID_PAYMENT_ERROR_CODES.some((invalidPaymentErrorCode) =>
        graphQLError.message.includes(invalidPaymentErrorCode),
      )
    );
  });
};
